import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import globals from '@/globals'

// Layouts
import LayoutHorizontalSidenav from '@/layout/LayoutHorizontalSidenav'

Vue.use(Router)
Vue.use(Meta)

const router = new Router({
    base: '/',
    mode: 'history',
    routes: [{
        path: '/',
        component: LayoutHorizontalSidenav,
        children: [
            {
                path: '', component: () => import('@/components/Home') },
            {
                name: 'customer-overview', path: 'market/customers/addresses', component: () => import('@/components/market/customers/CustomerOverview.vue')
            },
            {
                name: 'customer-edit', path: 'market/customers/addresses/:id', component: () => import('@/components/market/customers/CustomerEdit.vue')
            },
            {
                name: 'offer-overview', path: 'market/orders/offer', component: () => import('@/components/market/orders/OfferOverview.vue')
            },
            {
                name: 'po-overview', path: 'market/orders/po', component: () => import('@/components/market/orders/PoOverview.vue')
            },
            {
                name: 'invoice-overview', path: 'market/orders/invoices', component: () => import('@/components/market/orders/InvoiceOverview.vue')
            },
            {
                name: 'creditnotes-overview', path: 'market/orders/creditnotes', component: () => import('@/components/market/orders/creditnotes/CreditnotesOverview.vue')
            },
            {
                name: 'creditnotes-edit', path: 'market/orders/creditnotes/:id', component: () => import('@/components/market/orders/creditnotes/CreditnotesEdit.vue')
            },
            {
                name: 'books-overview', path: 'program/books', component: () => import('@/components/program/Books.vue') },
            {
                name: 'books-edit', path: 'program/books-edit/:id', component: () => import('@/components/program/BooksEdit.vue')
            },
            {
                path: '*', component: () => import('@/components/PageNotFound') }
        ]
    }]
})

router.afterEach(() => {
    // On small screens collapse sidenav
    if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
        setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
    }

    // Scroll to top of the page
    globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
    // Set loading state
    document.body.classList.add('app-loading')

    // Add tiny timeout to finish page transition
    setTimeout(() => next(), 10)
})

export default router
